export class AddonLimitBelowActiveCountError extends Error {
  constructor(message: string) {
    super(message)
    Object.setPrototypeOf(this, AddonLimitBelowActiveCountError.prototype)
  }
}
